import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InputSearch from '../../common/InputSearch';
import styles from './ImportReport.module.scss';
import { getCodesForImportReportRequest } from './services/actions';
import { importReportSelector } from './services/selector';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers';
import { Button, TextField } from '@mui/material';
import moment from 'moment';
import { Spinner } from '../../common/Spinner/Spinner';
import ErrorResponse from '../../shared/ErrorResponse';
import { ImportReportTable } from '../../common/ImportReportTable/ImportReportTable';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '../../../icons/arrow_back.svg';
import ArrowForwardIcon from '../../../icons/arrow_forward.svg';

const calendarStyle = {
  '.MuiInputBase-formControl': {
    backgroundColor: '#ffffff !important',
    height: 30,
    fontSize: '13px !important',
  },
  '.MuiOutlinedInput-notchedOutline': {
    borderColor: '#B0BEC5 !important',
    fontSize: '13px !important',
  },
  '.MuiSvgIcon-root': {
    fontSize: '18px !important',
  },
};

export const ImportReport: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let timeoutId: NodeJS.Timeout | null = null;

  const [calendarDate, setCalendarDate] = useState<any>(new Date());

  const handleMonthChange = (increment: number) => {
    const newDate = new Date(calendarDate);
    newDate.setMonth(newDate.getMonth() + increment);
    setCalendarDate(newDate);
  };

  const filterAvailableCodes = () => {
    dispatch(
      getCodesForImportReportRequest({
        fromDate: moment(calendarDate).format('YYYY-MM-01'),
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        toDate: moment(calendarDate).format('YYYY-MM-') + moment(calendarDate).daysInMonth(),
      }),
    );
  };

  const changeDateCalendar = (calendarValue: any) => {
    const newDate = new Date(calendarValue);
    newDate.setMonth(newDate.getMonth());
    setCalendarDate(newDate);
  };

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    timeoutId = setTimeout(() => {
      filterAvailableCodes();
      timeoutId = null;
    }, 1000);

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [calendarDate]);

  const { codesForImportReportResponse, loading, codesForImportReportErrorResponses } =
    useSelector(importReportSelector);

  const [tableData, setTableData] = useState<any[]>(codesForImportReportResponse);

  useEffect(() => {
    dispatch(
      getCodesForImportReportRequest({
        fromDate: moment(calendarDate).format('YYYY-MM-01'),
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        toDate: moment(calendarDate).format('YYYY-MM-') + moment(calendarDate).daysInMonth(),
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (Object.keys(codesForImportReportResponse).length !== 0 && codesForImportReportResponse?.status === 403) {
      navigate('/error');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codesForImportReportResponse]);

  return (
    <div className={styles.wrapper}>
      {Object.keys(codesForImportReportErrorResponses).length !== 0 ? (
        <ErrorResponse error={codesForImportReportErrorResponses} />
      ) : null}
      <section className={styles.codesHeader}>
        <div className={styles.loadingGroup}>
          <span className={styles.bankCodesSubTitle}>Звіт з імпорту кодів маркування</span>
          {loading ? <Spinner /> : null}
        </div>
        <span className={styles.bankCodesAdditionalText}>Історія завантаження кодів маркування</span>
      </section>
      <section className={styles.block}>
        <div className={styles.tools}>
          <div className={styles.calendarBlock}>
            <div className={styles.calendarItem}>
              <span>Дані за пeріод:</span>
              <div className={styles.calendarRow}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    inputFormat="MM/YYYY"
                    value={calendarDate}
                    views={['year', 'month']}
                    onChange={changeDateCalendar}
                    renderInput={(params) => <TextField sx={calendarStyle} {...params} />}
                    PaperProps={{
                      sx: {
                        '.MuiPickersCalendarHeader-label': {
                          fontSize: '13px',
                        },
                        '& .PrivatePickersYear-yearButton': {
                          fontSize: '13px',
                        },
                        '& .MuiTypography-root': {
                          fontSize: '13px',
                        },
                      },
                    }}
                  />
                  <img src={ArrowBackIcon} onClick={() => handleMonthChange(-1)} alt="" />
                  <img src={ArrowForwardIcon} onClick={() => handleMonthChange(1)} alt="" />
                </LocalizationProvider>
              </div>
            </div>

            <Button variant="contained" className={styles.btn} onClick={filterAvailableCodes}>
              <span className={styles.btnText}>Пошук</span>
            </Button>
          </div>
        </div>
        <div className={styles.searchBlock}>
          <span>Фільтр по всім полям:</span>
          <InputSearch setTableData={setTableData} data={codesForImportReportResponse} clearOnPropsChange={true} />
        </div>
      </section>
      <ImportReportTable data={tableData} />
    </div>
  );
};
